const TechnicalItem = ({ label, value, hide }) => {
  if (hide) {
    return null
  }

  return (
    <div className="flex gap-3 pb-1 mb-2 justify-between items-start text-sm border-b border-gray-200">
      <span className="shrink-0">{label}:</span>
      <span className="min-w-0 wrap-anywhere text-right font-semibold">
        {value === '' || value === null || value === undefined
          ? 'Not available'
          : value}
      </span>
    </div>
  )
}

const TechnicalInfo = ({ vehicle }) => {
  if (vehicle.technicalInfo) {
    const labels = {
      ecuManufacturer: 'ECU Manufacturer',
      ecuType: 'ECU Type',
      kess3: 'KESS3',
      kessv2: 'KESSv2',
      kessv2Protocol: 'KESSv2 Protocol',
      ktag: 'KTag',
      ktagFamily: 'KTag Family',
      ktagProtocol: 'KTag Protocol',
      ktagTsm: 'KTag TSM',
      ktagDifficulty: 'KTag Difficulty',
      cmd: 'CMD',
      autotuner: 'Autotuner',
      mmsX17: 'MMS X17',
      obdLocation: 'OBD Location',
      ecuLocation: 'ECU Location',
      ecuOpening: 'ECU Opening',
      note1: 'Note 1',
      note2: 'Note 2',
    }
    return (
      <div>
        <h4 className="text-base font-medium">Technical information</h4>
        <div className="mt-4">
          <TechnicalItem label="Engine Code" value={vehicle.engineCode} />
          {Object.entries(labels).map(([field, label]) => (
            <TechnicalItem
              key={field}
              label={label}
              value={vehicle.technicalInfo[field]}
              hide={
                (field === 'note1' || field === 'note2') &&
                (!vehicle.technicalInfo[field]?.trim() ||
                  /^not available$/i.test(vehicle.technicalInfo[field].trim()))
              }
            />
          ))}
        </div>
      </div>
    )
  }
  return (
    <div>
      <h4 className="text-base font-medium">Technical information</h4>
      <div className="mt-4">
        <TechnicalItem label="Model generation" value={vehicle.modelGen} />
        <TechnicalItem label="Model code" value={vehicle.modelCode} />
        <TechnicalItem label="Engine code" value={vehicle.engineCode} />
        <TechnicalItem label="ECU brand" value={vehicle.ecuBrand} />
        <TechnicalItem label="ECU version" value={vehicle.ecuVersion} />
        <TechnicalItem
          label="KTAG group"
          value={vehicle.ktagGroup}
          hide={vehicle.ktagGroup === ''}
        />
        <TechnicalItem
          label="KTAG protocol"
          value={vehicle.ktagProtocol}
          hide={vehicle.ktagProtocol === ''}
        />
        <TechnicalItem
          label="Communication"
          value={vehicle.communication}
          hide={vehicle.communication === ''}
        />
        <TechnicalItem
          label="CMD"
          value={vehicle.cmd}
          hide={vehicle.cmd === ''}
        />
        <TechnicalItem
          label="X17"
          value={vehicle.x17}
          hide={vehicle.x17 === ''}
        />
        <TechnicalItem
          label="KESSv2 protocol"
          value={vehicle.kessProtocol}
          hide={vehicle.kessProtocol === ''}
        />
        <TechnicalItem
          label="KESSv2 method"
          value={vehicle.kessMethod}
          hide={vehicle.kessMethod === ''}
        />
        <TechnicalItem label="Vehicle ref" value={`VDR-${vehicle.vehicleId}`} />
      </div>
    </div>
  )
}

export default TechnicalInfo
